package dev.youndie.site.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.silk.components.navigation.Link
import dev.youndie.site.model.BLOG_VISIBLE
import dev.youndie.site.model.GITHUB
import dev.youndie.site.model.SITE_NAME
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Nav
import org.jetbrains.compose.web.dom.Text

private class NavItem(val path: String, val label: String)

private val NAV_ITEMS: List<NavItem>
    get() = buildList {
        add(NavItem("/", "home"))
        add(NavItem("/about", "about"))
        if (BLOG_VISIBLE) add(NavItem("/blog", "blog"))
    }

private fun isActive(current: String, path: String): Boolean =
    if (path == "/") current == "/" else current.startsWith(path)

@Composable
fun SiteNav(ctx: PageContext) {
    val current = ctx.route.path

    Nav(attrs = { classes("nav") }) {
        Div(attrs = { classes("nav-inner") }) {
            Link("/", SITE_NAME, Modifier.classNames("nav-brand"))

            Div(attrs = { classes("nav-links") }) {
                NAV_ITEMS.forEach { item ->
                    // classNames() takes one token per argument - never a space-separated string.
                    val modifier = if (isActive(current, item.path)) {
                        Modifier.classNames("nav-link", "is-active")
                    } else {
                        Modifier.classNames("nav-link")
                    }
                    Link(item.path, item.label, modifier)
                }
                A(href = GITHUB, attrs = {
                    classes("nav-link")
                    target(ATarget.Blank)
                    attr("rel", "noopener")
                }) { Text("github") }
            }
        }
    }
}
